import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModalOptions, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'angular-2-local-storage';
import { environment } from "../../../environments/environment";
import { User } from "./../../models/UserObj";
import { AuthService, CommonService, DashboardService } from './../../services';
import { UserPreference } from '../../models/UserPreference';
import { appSettings, errorMessages } from '../../settings';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('ForgotPassword') ForgotPasswordModal;
  @ViewChild('ChangePassword') ChangePasswordModal;
  @ViewChild('EULA') EulaModal;
  changePasswordModalRef: NgbModalRef;
  forgotPasswordModalRef: NgbModalRef;
  eulaModalRef: NgbModalRef;

  username: string;
  password: string;
  npassword: string;
  cpassword: string;
  opassword: string;
  fpusername: string;
  opasswordErr: boolean;
  npasswordErr: boolean;
  cpasswordErr: boolean;

  loading = false;
  returnUrl: string;
  authenticated: boolean = false;
  submitted: boolean = false;
  errorMessage: string = "";
  fpErrorMessage: string = "";
  cpErrorMessage: string = "";
  cpPwdMismatch: boolean = false;
  HasWIPAccess: boolean = false;
  now1: Date = new Date();
  model1: NgbDateStruct;
  date: { year: number, month: number };
  user: User;
  passwordResetStatus: boolean = false;
  eulaChecked: boolean = false;

  selFacilityId: string;
  selFacilityName: string;
  selCustomerId: string;
  selCustomerName: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private _authService: AuthService,
    private _commonService: CommonService,
    private _dashboardService: DashboardService,
    @Inject(DOCUMENT) private document: any,
    private _localStorageService: LocalStorageService,
    private _ngbModal: NgbModal) {
  }

  ngOnInit() {

    //Check session active
    this.loadActiveSession();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  loadActiveSession() {
    this.user = this._commonService.getUser();
    if (this.user && this.user.Token) {
      this.createSession();
    }
  }

  selectToday() {
    this.model1 = { year: this.now1.getFullYear(), month: this.now1.getMonth() + 1, day: this.now1.getDate() };
  }

  login() {
    console.log('Login');
    if (this.username && this.password) {
      // reset login status       
      this._authService.logout();
      this.loading = true;
      console.time('Authenticate');
      this._authService.login(this.username, this.password)
        .subscribe(response => {
          console.timeEnd('Authenticate');
          if (response) {
            //console.log(response);
            this.submitted = true;
            this.errorMessage = response.Message;
            if (response.User) {
              response.User.UserAccessLevels = response.User.UserAccessLevels.filter(x => x.InactiveHost != this.document.location.hostname)
            }

            if (response.Status && response.StatusCode === 201) {
              console.log('User login success.');
              this._commonService.setUser(response);
              this.user = this._commonService.getUser();
              this.createSession()
            }
            else {
              this.loading = false;
            }
          }
          else {
            this.loading = false;
          }
        },
          error => {
            //Exception log
            console.timeEnd('Authenticate')
            console.log('Authenticate', error);
            this.loading = false;
            this.errorMessage = errorMessages.apiError;
          });
    }
    else {
      this.submitted = true;
      this.authenticated = false;
      //console.log('authenticated', this.authenticated);
      if (!this.username) {
        this.errorMessage = 'Username is required !';
      }
      else if (!this.password) {
        this.errorMessage = 'Password is required !';
      }
    }
  }

  createSession() {
    this.loading = true;
    this._localStorageService.set("userId", this.user.UserId);
    //OHL user is not allowed to reset password through this application
    if (this.user.ForcePasswordReset && !this.user.IsOhlEmployee) {
      //Change password component will display
      //WIP is for internal user and Change password is only valid for external users
      //this.showChangePassword();
    }
    else {
      let ctAccesslevel = this.getAccessLevel(environment.accessGroupKey, this.user.UserAccessLevels);
      if (ctAccesslevel) {
        console.log('User has WIP access.');
        this._localStorageService.set('HasWIPAccess', true);
        this.authenticated = true;

        if (this.user.EULA &&
          this.user.EULA.Language) {
          this.showEula();
        }
        else {
          this.setDefaults(this.user);
        }

      }
      else {
        console.log('User does not have access to WIP.');
        this.errorMessage = "You are not authorized to view WIP portal, Please contact administrator for access.";
        this.authenticated = false;
        this.loading = false;
      }
    }
  }

  getAccessLevel(accessGroupKey, accesslevels): any {
    let filteredAccessLevels = accesslevels.filter(x => x.AccessGroupKey == accessGroupKey);
    if (filteredAccessLevels !== undefined && filteredAccessLevels !== null && filteredAccessLevels.length > 0) {
      return filteredAccessLevels[0];
    }
    else
      return null;
  };

  setDefaults(user: User) {
    //OHL user is not allowed to reset password through this application
    let self = this;
    this.loading = true;
    if (user.ForcePasswordReset && !user.IsOhlEmployee) {
      // ChangePassword functionality
      this.showChangePassword();
    } else {
      console.time('getDefaultUserPreference');
      this._dashboardService.getDefaultUserPreference(user.UserName)
        .subscribe(data => {
          console.timeEnd('getDefaultUserPreference');
          if (data && data.CustomerId && data.FacilityId) {
            let userPref = new UserPreference();
            userPref.CustomerId = data.CustomerId;
            userPref.FacilityId = data.FacilityId;
            userPref.CustomerName = data.CustomerName;
            userPref.FacilityName = data.FacilityName;
            userPref.UserPreferenceId = data.UserPreferenceId;
            userPref.UserId = user.UserName;
            sessionStorage.setItem('userPreference', JSON.stringify(userPref));
            this.loading = false;
            self.router.navigateByUrl('/home');
          }
          else {
            this.createUserPreference(user);
          }
        },
          error => {
            //Exception log
            console.timeEnd('getDefaultUserPreference');
            console.log('getDefaultUserPreference', error);
            this.errorMessage = errorMessages.apiError;
            this.loading = false;
          });

    };
  }

  createUserPreference(user: User) {
    this.loading = true;
    console.time('getCustomers');
    this._dashboardService.getCustomers()
      .subscribe(response => {
        console.timeEnd('getCustomers');
        this.loading = false;
        if (response) {
          let customers: Array<any> = response;
          this.selCustomerId = customers[0].CustomerId;
          this.selCustomerName = customers[0].CustomerName;

          this.loading = true;
          console.time('getFacilities');
          this._dashboardService.getFacilities(this.selCustomerId)
            .subscribe(response => {
              console.timeEnd('getFacilities');
              this.loading = false;

              if (response) {
                let facilities: Array<any> = response;
                this.selFacilityId = facilities[0].FacilityId;
                this.selFacilityName = facilities[0].FacilityName;

                console.time('updateDefaultDashboard');
                this._dashboardService.updateDefaultDashboard(user.UserName, this.selFacilityId, this.selCustomerId, true)
                  .subscribe(response => {
                    console.timeEnd('updateDefaultDashboard');
                    this.loading = false;
                    this.setDefaults(user);
                  },
                  error => {
                    //Exception log
                    console.timeEnd('updateDefaultDashboard');
                    console.log('updateDefaultDashboard', error);
                    this.errorMessage = errorMessages.apiError;
                    this.loading = false;
                  });
              }
            },
            error => {
              //Exception log
              console.timeEnd('getCustomers');
              console.log('getCustomers', error);
              this.errorMessage = errorMessages.apiError;
              this.loading = false;
            });
        }
      },
      error => {
        //Exception log
        console.timeEnd('getFacilities');
        console.log('getFacilities', error);
        this.errorMessage = errorMessages.apiError;
        this.loading = false;
      });
  }

  openForgotPassword() {
    //WIP is for internal user and ForgotPassword is only valid for external users
  }

  forgotPassword() {
    this.passwordResetStatus = false;
    if (this.fpusername && this.fpusername.trim() != "") {
      let param = {
        Username: this.fpusername
      };
      console.time('forgotPassword');
      this._authService.forgotPassword(param)
        .subscribe(status => {
          console.timeEnd('forgotPassword');
          if (status !== undefined && status !== null) {
            //this.passwordResetStatus = status;
            if (!status.IsOhlEmployee) {
              if (status.Success) {
                this.fpusername = "";
                this.passwordResetStatus = true;
              }
              this.fpErrorMessage = status.Message
            }
          }
          else {
            this.fpErrorMessage = "Unable to reset password at this moment";
          }
        },
          error => {
            //Exception log
            console.timeEnd('forgotPassword');
            console.log('forgotPassword', error);
            this.errorMessage = errorMessages.apiError;
          });
    } else {
      this.fpErrorMessage = "Username is required";
    }
  }

  cancelForgotPassword() {
    this.fpErrorMessage = "";
    this.passwordResetStatus = false;
    this.forgotPasswordModalRef.close()
  }

  showChangePassword() {
    //this.ChangePasswordModal.open();
    //WIP is for internal user and ForgotPassword is only valid for external users
    let options: NgbModalOptions;
    options = {
      backdrop: "static",
      keyboard: false//,      
      //size: "lg"
    };
    this.changePasswordModalRef = this._ngbModal.open(this.ChangePasswordModal, options);
    this.loading = false;
  }

  comparePwds() {
    this.cpPwdMismatch = false;
    if (this.npassword && this.npassword.trim() != ""
      && this.cpassword && this.cpassword.trim() != ""
      && this.npassword.trim() == this.cpassword.trim()) {
      this.cpPwdMismatch = true;
    }
  }

  changePassword() {
    this.cpErrorMessage = "";
    this.opasswordErr = false;
    this.npasswordErr = false;
    this.cpasswordErr = false;
    if (this.opassword && this.opassword.trim() != ""
      && this.npassword && this.npassword.trim() != ""
      && this.cpassword && this.cpassword.trim() != ""
      && this.npassword.trim() == this.cpassword.trim()) {
      let credentials: any = {};
      credentials.UserId = this.user.UserId;
      credentials.Password = this.opassword.trim();
      credentials.NewPassword = this.npassword.trim();
      credentials.ForceReset = false;
      console.time('changePassword');
      this._authService.changePassword(credentials)
        .subscribe(data => {
          console.timeEnd('changePassword');
          if (data.Status) {
            this.opassword = "";
            this.npassword = "";
            this.cpassword = "";
            this._commonService.setUser(data);
            this.user = this._commonService.getUser();
            this.changePasswordModalRef.close();
            this.createSession();
          }
        },
          error => {
            //Exception log
            console.timeEnd('changePassword');
            console.log('changePassword', error);
            this.errorMessage = errorMessages.apiError;
          });
    }
    else {
      this.cpErrorMessage = "Please fill the required fields!";
      if (!this.opassword || this.opassword.trim() == "") {
        this.opasswordErr = true;
      }

      if (!this.npassword || this.npassword.trim() == "") {
        this.npasswordErr = true;
      }

      if (!this.cpassword || this.cpassword.trim() == "") {
        this.cpasswordErr = true;
      }

      if (this.npassword.trim() != "" && this.cpassword.trim() != ""
        && this.npassword.trim() != this.cpassword.trim()) {
        this.cpErrorMessage = "New Password and Confirm Password did not match!";
      }
    }
  }

  cpCancel() {
    this.changePasswordModalRef.close();
    this._authService.logout();
    this.router.navigate(["/login"]);
  }

  showEula() {
    let options: NgbModalOptions;
    options = {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    };
    this.eulaModalRef = this._ngbModal.open(this.EulaModal, options);
    this.loading = false;
  }

  eulaOk() {
    if (this.eulaChecked == true) {
      let eula = this.user.EULA;
      eula.Language = "";
      console.time('saveEULAUserResponse');
      this._authService.saveEULAUserResponse(eula)
        .subscribe(data => {
          console.timeEnd('saveEULAUserResponse');
          this._localStorageService.remove("EULA");
          this.user = this._commonService.getUser();
          this.eulaModalRef.close();
          this.createSession();
        },
          error => {
            //Exception log
            console.timeEnd('saveEULAUserResponse');
            console.log('saveEULAUserResponse', error);
            this.errorMessage = errorMessages.apiError;
          });
    }
    else {
      this.eulaCancel();
    }
  }

  eulaCancel() {
    this.eulaModalRef.close();
    this._authService.logout();
    this.router.navigate(["/login"]);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts